module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left side-menu"
  }, [_c('div', {
    staticClass: "sidebar-inner slimscrollleft"
  }, [_c('div', {
    attrs: {
      "id": "sidebar-menu"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "text-muted menu-title"
  }, [_vm._v("Navigation")]), _vm._v(" "), _vm._l((_vm.keystone.config.app.menu), function(item) {
    return _c('li', {
      key: item.to
    }, [_c('router-link', {
      staticClass: "waves-effect",
      attrs: {
        "to": item.to
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(item.text) + " ")])])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ba0fc8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/MainLeftMenu.vue
// module id = 664
// module chunks = 1